import { render } from "./DayViewWorkAreaModal.vue?vue&type=template&id=64cac47e"
import script from "./DayViewWorkAreaModal.vue?vue&type=script&lang=ts"
export * from "./DayViewWorkAreaModal.vue?vue&type=script&lang=ts"
script.render = render

export default script